export class FilebeatLogTypeModel {
    name;
    value;
}
//# sourceMappingURL=filebeat-log-type.js.map